import React from 'react'
import pdfLogo from 'images/pdf-logo.png'
import bg from 'images/personas/bg-content-talking.jpg'
import LimitedViewText from './LimitedViewText'

const TopPhrases = ({
                    phrases, limitedView, photo
                  }) => {
  const content = (
    <React.Fragment>
      <div
        className="bg-center bg-cover bg-no-repeat col-6 relative sm-col-12"
        style={{ backgroundImage: `url('${photo[0].url}')` }}
      >
        <div className="flex pt4 px4 relative sm-p3 z1">
          <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
          <div className="bg-violet-red mr2 rounded-6" style={{ height: 20, width: 20 }} />
          <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
          <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
        </div>

        <div className="image-layer image-layer--black absolute bottom-0 left-0 right-0 top-0" />

        <p className="persona-sub-title px4 py3 relative sm-p3 text-white z1">What are they talking about?</p>
      </div>

      <div className="col-6 flex flex-column flex-justify-center p4 sm-col-12 sm-px0 sm-py3 x-lg-p3">
        <p className="h2 mb3 x-lg-h3">The phrases they use and that are most trending related to your category are:</p>
        {limitedView ? <LimitedViewText /> : phrases.length > 0 && phrases.map(phrase => (<p className="fs-18">{phrase}</p>))}
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <section className="section" data-anchor="top_phrases">
        <div className="slider-box slider-box--sm-p0 slider-box--pdf-p0 bg-white box-shadow-box flex flex-wrap sm-flex-column-reverse">
          <div className="flex flex-wrap sm-py3">
            {content}
          </div>
        </div>
      </section>
    </React.Fragment>
  )
};

export default TopPhrases
